import { defineStore } from 'pinia';
import type { FilterModel } from '../services/ShortCodesService';

export const useShortCodesStore = defineStore('cms-shortcode-types', () =>
{
    const columns = reactive<Columns>({
        visible: {},
        positions: {}
    });
    const filter = reactive(Form.create<FilterModel>({
        name: null,
        symbol: null
    }));
    const pager = reactive(new Pager(1, 20, 'DateCreatedUtc', 'DESC'));
    const modalSection = ref('ShortCodesTypesGrid');
    const pagerListShortCodeOfGivenType = reactive(new Pager(1, 20, 'DateCreatedUtc', 'DESC'));

    return { columns, filter, pager, modalSection, pagerListShortCodeOfGivenType };
});
